
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/property-enquiry",
      function () {
        return require("private-next-pages/property-enquiry/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/property-enquiry"])
      });
    }
  